module.exports = __webpack_public_path__ + "images/select_shield_433a185.png";